angular.module('impactx.toolbar').component('ixListFilterToggle', {
    controller: 'ListFilterToggleCtrl',
    templateUrl: 'shared/toolbar/templates/list-filter-toggle.html',
    bindings: {
        showListFilterToggle: '=',
        showPersistentListFilters: '=',
        togglePersistentFilters: '=',
        toggleFilterSidebar: '=',
        isOpen: '=',
        selectedFilter: '=',
        alignLeft: '='
    }
});